import { ChangeEvent, FunctionComponent, KeyboardEvent, useState } from "react";
import { SearchIcon } from "@App/Components/common/Icons";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useDelayedInput } from "@App/hooks/useDelayedInput";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";

type GarageNameSearchProps = {
  className?: string;
};

export const GarageNameFilter: FunctionComponent<GarageNameSearchProps> = ({ className = "" }) => {
  const search = useSelector((state: State) => state.filters.search);
  const [delayedSearch, setDelayedSearch] = useState(search);
  const dispatch = useDispatch();
  const { changeNameFilter } = bindActionCreators(actionCreators, dispatch);

  useDelayedInput(
    [delayedSearch],
    () => {
      if (delayedSearch !== search) changeNameFilter(delayedSearch);
    },
    700,
  );

  const onChange = (e: ChangeEvent<HTMLInputElement>) => setDelayedSearch(e.target.value);
  const clear = () => {
    setDelayedSearch("");
    changeNameFilter("");
  };
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") changeNameFilter(delayedSearch);
  };
  const publishSearch = () => changeNameFilter(delayedSearch);

  return (
    <div className="relative">
      <div className={className}>
        <div className="relative md:w-80 max-w-full">
          <input
            value={delayedSearch ?? ""}
            type="text"
            placeholder="Name suchen"
            className="focus:outline-none w-full border focus:border-primary border-neutral-500 py-2 px-3 pr-8 rounded"
            onChange={onChange}
            onClick={(e) => e.currentTarget.select()}
            onKeyDown={handleKeyDown}
          />
          {delayedSearch && (
            <div onClick={clear} className="absolute top-3 right-12">
              <XMarkIcon className="w-4 h-4" />
            </div>
          )}
          <button
            type="button"
            className="absolute top-0 right-0 w-10 h-full"
            onClick={publishSearch}
          >
            <SearchIcon className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};
